export default "__VITE_ASSET__CIbbtX8x__"